export default "__VITE_ASSET__BVzWqP$M__"